<template>
    <form>
        <ui-container>
            <ui-form-section :title="editMode ? 'Change Operatives' : 'Create New Entry'"
                             subtitle="Log booked, present and absent operatives." class="py-8 border-b">
                <ui-date-picker :disabled="editMode" mode="multiple" :inline="!editMode" label="Date" name="date"
                                style="zIndex:0" :error="form.errors.get('date')" v-model="form.date"></ui-date-picker>

                <ui-select-searchable
                    v-if="showBookings"
                    label="Bookings"
                    placeholder="Operatives..."
                    v-model="form.bookings"
                    ref="booking"
                    :multiple="true"
                    :error="form.errors.get('bookings')"
                    :search="searchPeople"
                    no-search="Start typing to find operatives..."
                ></ui-select-searchable>


                <ui-select-searchable
                    v-if="showRegisterFields"
                    label="Present Operatives"
                    placeholder="Present Operatives..."
                    v-model="form.present"
                    :multiple="true"
                    :error="form.errors.get('present')"
                    :search="searchPeople"
                    no-search="Start typing to find operatives..."
                ></ui-select-searchable>
                <ui-select-searchable
                    v-if="showRegisterFields"
                    label="Absent Operatives"
                    placeholder="Absent Operatives..."
                    v-model="form.absent"
                    :multiple="true"
                    :error="form.errors.get('absent')"
                    :search="searchPeople"
                    no-search="Start typing to find operatives..."
                ></ui-select-searchable>


            </ui-form-section>
        </ui-container>

        <ui-container class="py-4 flex justify-end space-x-6">
            <ui-button-new v-if="editMode" @click="edit(false)">Cancel</ui-button-new>
            <ui-button-new v-else @click.prevent="form.reset()">Reset</ui-button-new>
            <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">
                {{ editMode ? 'Save' : 'Create' }}
            </ui-button-new>
        </ui-container>
    </form>
</template>

<script>
import {Contact, OperativePlanning} from '@models'
import {parseMoment} from "../../utils";

export default {
    props: {
        item: Object,
        edit: Function,
        refresh: Function,
        removeItem: Function,
        packageId: null,
    },
    data() {
        const initialData = this.item
            ? this.item.getFormAttributes()
            : {}
        initialData.package_id = this.packageId
        let that = this

        return {
            form: new Form(initialData, async (form) => {
                const data = form.export()

                data.editing = this.editMode
                if (this.editMode) {
                    this.item.update(data)

                    that.edit(false)
                } else {
                    const planning = await OperativePlanning.create(data)
                    form.reset()
                    that.refresh()

                }

            }),
        }
    },
    computed: {
        editMode() {
            return !!this.item
        },
        showBookings() {
            if (this.form.date) {
                if (this.editMode) {
                    // We're editing which means we don't support multiple dates
                    const parsedDate = parseMoment(this.form.date, 'YYYY-MM-DD', false)
                    return parsedDate.isAfter()
                } else {
                    let shouldShowBookings = false
                    this.form.date.split(", ").forEach((date) => {
                        // We're editing which means we don't support multiple dates
                        const parsedDate = parseMoment(date, 'YYYY-MM-DD', false)
                        if (parsedDate.isAfter()) {
                            shouldShowBookings = true
                        }
                    })
                    return shouldShowBookings
                }
            }


            return true
        },
        showRegisterFields() {
            if (this.form.date) {
                if (this.editMode) {
                    return !this.showBookings
                } else {
                    let shouldShowRegisterFields = false
                    this.form.date.split(", ").forEach((date) => {
                        // We're editing which means we don't support multiple dates
                        const parsedDate = parseMoment(date, 'YYYY-MM-DD', false)
                        if (!parsedDate.isAfter()) {
                            shouldShowRegisterFields = true
                        }
                    })
                    return shouldShowRegisterFields
                }

            }
        }
    },
    methods: {
        async searchPeople(query) {
            return (await Contact.search(query)).map(x => x.toDropdown())
        },
    },
}
</script>
